export class FilenameDto {
    fileName:string;
    
    constructor(fileName:string) {
        this.fileName = fileName;
    }
    
}

